import React, { useEffect, useState } from 'react';
import { Slider } from 'primereact/slider';
import { Checkbox } from 'primereact/checkbox';


export default function TonerSlider({ cor = 'P', color, valor = 0, onChange, disabled,checked,  setChecked, disabledCheckBox }) {
    const [monitorar, setMonitorar] = useState(checked)
    useEffect(()=>{
        if(setChecked ){
            setChecked(monitorar)
        }
        
    }, [monitorar])
   
    return (
        <div className="flex align-items-center gap-4 mb-2">
            {/* Letra da cor (P, C, M, A) */}
            <div style={{opacity : disabled ? 0.4 : 1}}>
                <div style={{
                    fontSize:'1.8rem',
                    padding : '1.4rem',
                    display:'flex', 
                    alignContent:'center', 
                    alignItems: 'center', 
                    textAlign: 'center', 
                    justifyContent:'center',
                    fontWeight
                    : 'bold', 
                    backgroundColor : color, 
                    height:'1.8rem', 
                    width : '1.8rem', 
                    color :'#fff'}}>                
                    {cor}
                
            </div>
            <span style={{display: 'block', fontSize : '0.8rem', width : '100%', textAlign:'center', marginTop : '2px'}}>{valor ? valor+'%' : 'N/D'}</span>
            </div>

            {/* Slider do PrimeReact */}
            <div style={{ flex: 1 }}>
                <div>
                    <Checkbox disabled={disabledCheckBox} checked ={monitorar} onClick={()=> setMonitorar(!monitorar)}/> <span className='text-small'>Habilitar Monitoramento {cor}</span>
                </div>
                <Slider
                    value={valor}
                    onChange={(e) => onChange && onChange(e.value)}
                    min={0}
                    max={100}
                    disabled ={disabled || !monitorar}
                    style={{ width: '100%' , marginTop : '25px'}}
                />
            </div>
        </div>
    );
}
